'use strict';

var React = require('react/addons'),
    PropTypes = React.PropTypes,
    BasicFormGroup;

/**
 * The base class of form group components in order to work properly with them.
 */
BasicFormGroup = {

    propTypes: {
        /**
         * Indicated that the component are enable or disabled.
         */
        isDisabled: PropTypes.bool,

        /**
         * Indicated that the component are enable or disabled.
         */
        additionalValidation: PropTypes.func,

        /**
         * Indicated that the component are required or not. (default should be required)
         */
        isRequired: PropTypes.bool,

        /**
         * The context holder to be use to handler each operation of the group component.
         */
        operationsHolder: PropTypes.object.isRequired,

        /**
         * The name of the attribute that will show the component.
         */
        displayAttribute: PropTypes.string.isRequired,

        /**
         * The name of the attribute that will use to read the `selectedItem` in order retrieve the
         * current `value` defined.
         */
        readerAttribute: PropTypes.string.isRequired,

        /**
         * Pre defined input value. (Optionally)
         */
        value: PropTypes.any,

        /**
         * The name of the attribute that will retrieve the current `value` defined.
         */
        writerAttribute: PropTypes.string.isRequired,

        /**
         * The label of the group form component. (Optionally)
         */
        label: PropTypes.string,

        /**
         * The name of the component to be use to show in validation messages.
         */
        name: PropTypes.string
    }
};

module.exports = BasicFormGroup;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/BasicForm/BasicFormGroup.js
 **/